<template>
  <div class="dt-paging">
    <div class="item-per-page" :class="pagingObj.itemsPerPage == 'SHOW ALL' ? 'show-all' : null">
      <v-select class="select" v-model="pagingObj.itemsPerPage" :options="['25', '50', 'SHOW ALL']"
                :searchable="false"></v-select>
      <span class="text"> events on pages.</span>
    </div>
    <div class="select-page-number" v-if="itemsPerPage / totalItems <= 1">
      <b-pagination size="md" :total-rows="totalItems" v-model="pagingObj.currentPage"
                    :per-page="pagingObj.itemsPerPage == 'SHOW ALL' ? 10000 : parseInt(pagingObj.itemsPerPage)">
      </b-pagination>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import vSelect from 'vue-select';

  Vue.component('v-select', vSelect);

  export default {
    name: 'DtPaging',
    props: {
      currentPage: {
        type: Number,
        default: 1
      },
      itemsPerPage: {
        type: String,
        default: '25'
      },
      totalItems: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        pagingObj: {
          currentPage: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          totalItems: this.totalItems
        }
      }
    },
    computed: {},
    watch: {
      pagingObj: {
        handler (newPagingObj) {
          // emit data to parent
          this.$emit('CHANGE_PAGING_OPTIONS', newPagingObj);
        },
        deep: true
      }
    }
  };
</script>

<style lang="less">
  @import '../../styles/variables.less';
  @import '../../styles/customstyle.less';

  .dt-paging {
    .item-per-page {
      float: left;
      .text {
        float: left;
      }
      .select {
        float: left;
      }
      .selected-tag {
        padding: 0 5px !important;
      }
      .dropdown-toggle {
        width: 60px !important;
        background-color: @white;
        margin-top: 0;
        &:after {
          position: absolute;
          right: 5px;
          top: 10px;
        }
      }
      &.show-all {
        .dropdown-toggle {
          width: 115px !important;
        }
      }
      .dropdown-menu {
        height: 120px;
      }
      .text {
        line-height: 30px;
        padding: 0 5px;
      }
      .open-indicator {
        position: absolute;
        top: 12px;
        bottom: unset;
      }
      .open {
        .open-indicator {
          top: 15px;
        }
      }
    }
    .select-page-number {
      width: 300px;
      margin: 10px auto;
      .page-item {
        a {
          color: @blue;
        }
        &.active {
          a {
            color: @white;
            border-color: @blue;
            background-color: @blue;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// DtPaging.vue?3fcc07f2